export const lightTheme = {
  background: '#f8f7f4',
  color: '#1a1a1a',
  accentColor: '#2d2d2d',
  accentHover: '#1a1a1a',
  secondaryAccentColor: '#5c5c5c',
  chronoTheme: {
    cardBgColor: '#ffffff',
    cardForeColor: '#1a1a1a',
    titleColor: '#1a1a1a',
  },
  timelineLineColor: '#e5e5e0',
  cardBackground: '#ffffff',
  cardFooterBackground: '#fafaf8',
  cardBorderColor: '#e5e5e0',
  navbarTheme: {
    linkColor: '#5c5c5c',
    linkHoverColor: '#1a1a1a',
    linkActiveColor: '#ffffff',
    bgColor: '#1a1a1a',
    borderColor: 'transparent',
    linkHoverBg: 'rgba(255, 255, 255, 0.1)',
    linkActiveBg: 'rgba(255, 255, 255, 0.15)',
  },
  footerBg: '#1a1a1a',
  sectionBg: '#f0efea',
  sectionBgImage: 'none',
  pillBg: 'rgba(26, 26, 26, 0.06)',
  pillActiveBg: 'rgba(26, 26, 26, 0.12)',
  bsPrimaryVariant: 'light',
  bsSecondaryVariant: 'dark',
  socialIconBgColor: '#1a1a1a',
  textPrimary: '#1a1a1a',
  textSecondary: '#5c5c5c',
  textMuted: '#8c8c8c',
  borderColor: '#e5e5e0',
  shadowColor: 'rgba(26, 26, 26, 0.08)',
  successColor: '#059669',
  warningColor: '#d97706',
  dangerColor: '#dc2626',
  infoColor: '#0284c7',
};

export const darkTheme = {
  background: '#0d0d0d',
  color: '#f5f5f5',
  accentColor: '#f5f5f5',
  accentHover: '#ffffff',
  secondaryAccentColor: '#a3a3a3',
  chronoTheme: {
    cardBgColor: '#1a1a1a',
    cardForeColor: '#f5f5f5',
    titleColor: '#f5f5f5',
  },
  timelineLineColor: '#2d2d2d',
  cardBackground: '#1a1a1a',
  cardFooterBackground: '#0d0d0d',
  cardBorderColor: '#2d2d2d',
  navbarTheme: {
    linkColor: '#a3a3a3',
    linkHoverColor: '#f5f5f5',
    linkActiveColor: '#ffffff',
    bgColor: '#1a1a1a',
    borderColor: 'transparent',
    linkHoverBg: 'rgba(255, 255, 255, 0.08)',
    linkActiveBg: 'rgba(255, 255, 255, 0.15)',
  },
  footerBg: '#0d0d0d',
  sectionBg: '#161618',
  sectionBgImage: "url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920')",
  pillBg: 'rgba(255, 255, 255, 0.06)',
  pillActiveBg: 'rgba(255, 255, 255, 0.12)',
  bsPrimaryVariant: 'dark',
  bsSecondaryVariant: 'light',
  socialIconBgColor: '#f5f5f5',
  textPrimary: '#f5f5f5',
  textSecondary: '#a3a3a3',
  textMuted: '#737373',
  borderColor: '#2d2d2d',
  shadowColor: 'rgba(0, 0, 0, 0.4)',
  successColor: '#10b981',
  warningColor: '#f59e0b',
  dangerColor: '#ef4444',
  infoColor: '#0ea5e9',
};
